// export const DOMAIN = "http://localhost:2500/api";

export const DOMAIN = "https://whatbox.io/api";
